export const generateTimeOptions = (ranges: any[], step: number) => {
	const options: any = [];
	const now = new Date();
	const currentHours = now.getHours().toString().padStart(2, '0');
	const currentMinutes = now.getMinutes().toString().padStart(2, '0');
	const currentTimeStr = `${currentHours}:${currentMinutes}`;
	const currentTime = new Date(`1970-01-01T${currentTimeStr}:00`);
	
	ranges.forEach((range: any) => {
		const [start, end] = range.split('-');
		const startTime = new Date(`1970-01-01T${start}:00`);
		const endTime = new Date(`1970-01-01T${end}:00`);
		
		if (currentTime >= startTime && currentTime <= endTime) {
			const diffMinutes = currentTime.getMinutes() % step;
			const minutesToAdd = diffMinutes === 0 ? step : step - diffMinutes;
			let nextTime = new Date(currentTime);
			nextTime.setMinutes(nextTime.getMinutes() + minutesToAdd);
			
			while (nextTime <= endTime) {
				const hours = nextTime.getHours().toString().padStart(2, '0');
				const minutes = nextTime.getMinutes().toString().padStart(2, '0');
				options.push(`${hours}:${minutes}`);
				nextTime.setMinutes(nextTime.getMinutes() + step);
			}
			
			const lastHours = endTime.getHours().toString().padStart(2, '0');
			const lastMinutes = endTime.getMinutes().toString().padStart(2, '0');
			const lastTime = `${lastHours}:${lastMinutes}`;
			if (options.length === 0 || options[options.length - 1] !== lastTime) {
				options.push(lastTime);
			}
		}
		else if (currentTime < startTime) {
			const firstHours = startTime.getHours().toString().padStart(2, '0');
			const firstMinutes = startTime.getMinutes().toString().padStart(2, '0');
			options.push(`${firstHours}:${firstMinutes}`);
			
			let currentTimeInRange = new Date(startTime);
			currentTimeInRange.setMinutes(currentTimeInRange.getMinutes() + step);
			
			while (currentTimeInRange < endTime) {
				const hours = currentTimeInRange.getHours().toString().padStart(2, '0');
				const minutes = currentTimeInRange.getMinutes().toString().padStart(2, '0');
				options.push(`${hours}:${minutes}`);
				currentTimeInRange.setMinutes(currentTimeInRange.getMinutes() + step);
			}
			
			const lastHours = endTime.getHours().toString().padStart(2, '0');
			const lastMinutes = endTime.getMinutes().toString().padStart(2, '0');
			const lastTime = `${lastHours}:${lastMinutes}`;
			if (options[options.length - 1] !== lastTime) {
				options.push(lastTime);
			}
		}
	});
	
	return Array.from(new Set(options));
};